export const BuildInfo = {timestamp:1789772947000}
